import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { handleSortingMenu, handleDataForSidebar, setExceptionHandler, getModalSwitch } from '@app/store/actions';
import { IListPageBarEnabled } from '@app/models';
import { IMenuItem } from '@app/components';

export const useSetPage = (options: IListPageBarEnabled | null, menu?: IMenuItem) => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (options !== null) dispatch(handleSortingMenu(options));
        dispatch(handleDataForSidebar(menu));
        dispatch(getModalSwitch(false));
        dispatch(setExceptionHandler(true));

    }, []);
};
